<label [class]="('custom-checkbox ' + customClass).trim()" [ngClass]="{'disabled': isDisabled}" [style]="customStyle">
    <input type="checkbox" [checked]="isChecked ? isChecked : null" [disabled]="isDisabled" (change)="toggleCheckbox($event)" [name]="name">
    <span class="checkmark" [ngClass]="{'no-animation': noAnimation}" [class.checked]="isChecked" [style]="checkMarkStyle"></span>
    <ng-content class="content"></ng-content>
</label>